<div class="page-static public-portal-right-col" style="overflow-y: scroll; height: 100%;">
	<div class="form-screen" id="mobile-referral">
		<div class="img-wrapper">
			<img [alt]="appName" [src]="logoSrc" [alt]="appName + ' App'">
		</div>

		<div class="title-wrapper">

			<h2>{{downloadTitle}}</h2>

			<div style="text-align: left;">
				<p>{{downloadDescription}}</p>

				<div id="download">
					<a tabindex="0" target="_blank" class="wt-auto-google-store google"
						[href]="playStore">
						<img alt="Get it on Google Play" src="/assets/img/icons/google-play-badge@2.png" />
					</a>
					<a tabindex="0" target="_blank" class="wt-auto-apple-store apple"
						[href]="appStore">
						<img alt="Download on the App Store"
							src="/assets/img/icons/Download_on_the_App_Store_Badge_US-UK_564x167@2.png">
					</a>
				</div>

				<p class="strong">Once you've downloaded the app:</p>
				<ul>
					<li>Click on this link for full access:<br>
						<a [href]="referralUrl">{{referralUrl}}</a></li>

					<li>Create your account with any email you like and follow the on screen steps</li>
					<li>Verify your account using the link in the email we send you from <a
							href="mailto:noreply@welltrack.com">noreply&#64;welltrack.com</a></li>
					<li *ngIf="isNMConnect">Login and enjoy using NMConnect's self help resources, provided by Welltrack Boost</li>
					<li *ngIf="!isNMConnect">Login and enjoy using Welltrack Boost's self help resources</li>
				</ul>
			</div>
		</div>
	</div>
</div> 